var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 0.75,
    y: 0.75,
    width: 37.5,
    height: 37.5,
    rx: 18.75,
    stroke: "#E40F94",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0508 31H16.848C16.313 31 15.8778 30.5648 15.8778 30.0298V22.8057H14.0092C13.4742 22.8057 13.0391 22.3704 13.0391 21.8355V18.74C13.0391 18.205 13.4742 17.7698 14.0092 17.7698H15.8778V16.2197C15.8778 14.6827 16.3604 13.375 17.2734 12.4382C18.1904 11.4973 19.472 11 20.9796 11L23.4222 11.004C23.9563 11.0049 24.3907 11.4401 24.3907 11.9741V14.8483C24.3907 15.3832 23.9557 15.8184 23.4208 15.8184L21.7762 15.819C21.2747 15.819 21.147 15.9196 21.1196 15.9504C21.0746 16.0016 21.0211 16.146 21.0211 16.545V17.7697H23.2973C23.4686 17.7697 23.6346 17.812 23.7773 17.8916C24.0851 18.0636 24.2764 18.3887 24.2764 18.7402L24.2752 21.8357C24.2752 22.3704 23.84 22.8056 23.305 22.8056H21.0211V30.0298C21.0211 30.5648 20.5858 31 20.0508 31ZM17.0503 29.8275H19.8484V22.2809C19.8484 21.9237 20.1391 21.6331 20.4962 21.6331H23.1027L23.1038 18.9424H20.496C20.139 18.9424 19.8484 18.6519 19.8484 18.2946V16.5451C19.8484 16.087 19.895 15.5661 20.2407 15.1745C20.6586 14.7012 21.317 14.6466 21.7759 14.6466L23.2182 14.646V12.1761L20.9787 12.1725C18.5559 12.1725 17.0503 13.7234 17.0503 16.2197V18.2946C17.0503 18.6516 16.7598 18.9423 16.4027 18.9423H14.2116V21.6331H16.4027C16.7598 21.6331 17.0503 21.9236 17.0503 22.2808L17.0503 29.8275Z",
    fill: "#E40F94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/Facebook Icon.1d0fbfdf19724491a074535fb102d760.svg";
export { ForwardRef as ReactComponent };